import React, { useEffect, useState } from 'react'
import TopBar from '../Layouts/TopBar'
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import Footer from '../Layouts/Footer';

function Enseignant() {
  const { acronym } = useParams();
  const [enseignants, setEnseignants] = useState([]);

  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');

  const [orderBy, setOrderBy] = useState('firstName'); // Default to sorting by first name
  const enseignantsParPage = 8;
  const pagesParSection = 5;


  const listEnseignants = () => {
    axios.get(`https://go.vecos.us/reunice/API/v1/Universitys/get/${acronym}`)
      .then(response => {
        // Sort the researchers based on the selected order
        const sortedEnseignants = response.data.researcher.sort((a, b) => {
          if (a[orderBy] < b[orderBy]) return -1;
          if (a[orderBy] > b[orderBy]) return 1;
          return 0;
        });

        console.log(response.data.researcher, "reeeeeeeeeeeeeeeeees");
        setEnseignants(response.data.researcher);

      })
      .catch(error => {
        console.error('Erreur lors de la récupération des données:', error);
      });
  }
  useEffect(() => {
    listEnseignants();
  }, []);



  const totalPages = Math.ceil(enseignants.length / enseignantsParPage);
  const totalSections = Math.ceil(totalPages / pagesParSection);
  const currentSection = Math.ceil(page / pagesParSection);

  const changePage = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  }

  const renderPagination = () => {
    const pages = [];
    const startPage = (currentSection - 1) * pagesParSection + 1;
    const endPage = Math.min(startPage + pagesParSection - 1, totalPages);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          className={`btn btn-outline-secondary ${page === i ? 'active' : ''}`}
          onClick={() => changePage(i)}
        >
          {i}
        </button>
      );
    }

    return pages;
  }

  const prevSection = () => {
    if (currentSection > 1) {
      setPage((currentSection - 2) * pagesParSection + 1);
    }
  }

  const nextSection = () => {
    if (currentSection < totalSections) {
      setPage(currentSection * pagesParSection + 1);
    }
  }

  const filteredEnseignants = enseignants.filter(enseignant =>
    enseignant.firstName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const startIndex = (page - 1) * enseignantsParPage;
  const endIndex = startIndex + enseignantsParPage;
  const currentEnseignants = filteredEnseignants.slice(startIndex, endIndex);

  return (

    <>
      <TopBar />

      <main className='mt-3'>
        <div className="container">
          <div className="row g-4">
            <div className="col">
              <div className="card ">
                <div className="card-header d-sm-flex justify-content-between align-items-center border-0">
                  <h5 className="card-title"> Lists of researchers

                    <span className=" badge bg-danger bg-opacity-10 text-danger ms-2"><b>{enseignants && enseignants.length}</b></span>
                  </h5>

                  <div className="nav mt-3 mt-lg-0 flex-nowrap align-items-center px-4 px-lg-0">
                    <div className="nav-item ">
                      <form className="rounded position-relative">
                        <input value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)} className="form-control ps-5 bg-light" type="search" placeholder="Search..." aria-label="Search" />
                        <button className="btn bg-transparent px-2 py-0 position-absolute top-50 start-0 translate-middle-y" type="submit"><i className="bi bi-search fs-5"> </i></button>
                      </form>
                    </div>
                  </div>
                </div>

                <div className="card-body position-relative pt-0 mt-3 mt-md-5">
                  <div className="row g-3">
                    {/* Card START */}
                    <div className="col-md-6 col-lg-12">

                      <div className="row g-4">
                        {currentEnseignants &&
                          currentEnseignants.map((d) => {
                            return (
                              <>
                                <div className=" col-6 col-md-3">
                                  {/* Friends item START */}
                                  <div className="card text-center p-3 h-100" style={{
                                    borderRadius: "50px"
                                  }}>
                                    {/* Card body */}
                                    <div className="card-body p-2 pb-0">
                                      <div className="avatar avatar-xl">
                                        <a href="#!"><img className="avatar-img rounded-circle" src={d.profilePicture} alt={enseignants.acronym} /></a>
                                      </div>
                                      <h6 className="card-title mb-1 mt-3"> <a href="#!">{d.firstName + (d.lastName ? ' ' + d.lastName : '')}
                                      </a></h6>
                                    
                                    </div>
                                    {/* Card footer */}

                                    <Link to={"/profil/" + d.id} ><button className="btn btn-sm btn-primary mt-2" > <i className="bi bi-eye" /> </button></Link>


                                  </div>
                                  {/* Friends item END */}
                                </div>

                              </>

                            )
                          })}
                        <div className="card-footer d-flex justify-content-center">
                          <button className="btn btn-outline-secondary" onClick={prevSection} disabled={currentSection === 1}>Previous</button>
                          {renderPagination()}
                          <button className="btn btn-outline-secondary" onClick={nextSection} disabled={currentSection === totalSections}>Next</button> 
                        </div>

                      </div>
                    </div>

                    {/* Card END */}


                  </div>




                </div>

              </div>
            </div>
          </div>
        </div>
      </main>
<Footer />







    </>
  )
}

export default Enseignant